import { shiftDemandFormModel } from './shiftDemandFormModel';
const {
  formField: { shiftTemplateId, positionId, date, requiredEmployees },
} = shiftDemandFormModel;

export default {
  [shiftTemplateId.name]: null,
  [positionId.name]: null,
  [date.name]: '',
  [requiredEmployees.name]: '',
};
